//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//import xxxxxxxx from 'zzzzzzzz.vue'
export default {
  name: 'xxxxxxxx',
  components: {
    //	xxxxxxxx
  },
  props: {
    type: {
      default: 1, //1是测试题,2是其他规则
    },
    qrImg: {
      default:
        'http://meitetest.oss-cn-hangzhou.aliyuncs.com/wechat/201908/165d5611487f36a.png',
    },
  },
  data() {
    return {}
  },
  created() {},
  mounted() {},
  methods: {
    changeCloseFn() {
      this.$emit('changeClose')
    },
    changeSkipFn() {
      this.$emit('changeSkip')
    },
  },
  computed: {},
}



// WEBPACK FOOTER //
// ./src/pages/components/Dialog.vue